import openSeat from '../../../../assets/openSeat.svg';
import { FC } from 'react';
import styles from './OpenSeat.module.css';

const OpenSeat: FC = () => {
  return (
    <>
      <div className={styles.openSeatButton}>
        <img src={openSeat} alt="Take this seat m-auto" className="mx-auto h-6 w-6" />
        <span className="mx-auto block text-sm text-opacity-50">Open Seat</span>
      </div>
    </>
  );
};

export default OpenSeat;
